import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { awsUrl } from "../../helpers";

const Portal = ({ portal, previewPortal, pinDrop }) => {
  const portalsRef = useRef();
  const [number, setNumber] = useState(0);

  const pinStyle = portal.pin;
  const pinAnimate = pinDrop ? `pin-dropped-` + number : "opacity-0";

  const portalSlug = (name) => {
    return name.replace(/\s+/g, "-").toLowerCase();
  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const handleKeyPress = (e) => {
    // console.log(e.keyCode);
    if (e.keyCode === 13 || e.keyCode === 32) {
      //check either enter or spacebar
      previewPortal();
    }
  };

  useEffect(() => {
    if (pinDrop) {
      setNumber(randomNumberInRange(1, 5));
    }
  }, [pinDrop, setNumber]);

  if (new Date(portal.release_timestamp) < Date.now()) {
    //unlocked
    return (
      <div
        ref={portalsRef}
        className={
          `my-2 portal z-50 absolute hover:cursor-pointer bounce pointer-events-auto pin pin-unlocked text-millik ` +
          pinStyle +
          ` ` +
          pinAnimate +
          ` portal-` +
          portal.key
        }
        key={portal.key}
        aria-label={`view ` + portal.name_unlocked}
      >
        <Link
          tabIndex={portal.key}
          to={`/portals/` + portalSlug(portal.name_unlocked)}
          aria-label={`view ` + portal.name_unlocked}
        >
          {" "}
          <img
            alt={`icon of ` + portal.name_unlocked}
            className="inline w-[24px] lg:w-[63px] cursor-pointer"
            src={awsUrl + `/media/portals/` + portal.key + `/pin.png?v=1`}
            srcSet={awsUrl + `/media/portals/` + portal.key + `/pin@2x.png?v=1`}
            aria-hidden="true"
          />
        </Link>

        <div className={portal.key + ` portal--title text-millik`} aria-hidden>
          {portal.name_unlocked}
        </div>
      </div>
    );
  } else {
    return (
      <div
        ref={portalsRef}
        className={
          `my-2 portal z-50 absolute hover:cursor-pointer bounce pointer-events-auto pin ` +
          pinStyle +
          ` ` +
          pinAnimate +
          ` portal-` +
          portal.key
        }
        key={portal.key}
        onClick={previewPortal}
        onKeyDown={(e) => handleKeyPress(e)}
        aria-label={`view ` + portal.name + ` portal`}
        tabIndex={portal.key}
        role="button"
      >
        <img
          alt="icon of map key"
          className="inline w-[24px] lg:w-[63px] cursor-pointer"
          src={awsUrl + `/media/map-key.png?v=1`}
          srcSet={awsUrl + `/media/map-key.png?v=1`}
          aria-hidden="true"
        />
        <div className="portal--title text-millik" aria-hidden>
          {portal.name} <span>Portal</span>
        </div>
      </div>
    );
  }
};

export default Portal;
